export default "__VITE_ASSET__e1cd1aa3__"